import {
  GET_DASHBOARD_FINISH_TASKS,
  GET_DASHBOARD_FINISH_TASKS_SUCCESS,
  GET_DASHBOARD_FINISH_TASKS_ERROR,
} from './actionTypes';

const initialState = {
  errorGetDashboardFinishTasks: '',
  loadingGetDashboardFinishTasks: false,
  tasks: null,
  successGetDashboardFinishTasks: '',
};

const getDashboardFinishTasks = (state = initialState, action) => {
  switch (action.type) {
    case GET_DASHBOARD_FINISH_TASKS:
      state = { ...state, loadingGetDashboardFinishTasks: true };
      break;
    case GET_DASHBOARD_FINISH_TASKS_SUCCESS:
      state = {
        ...state,
        loadingGetDashboardFinishTasks: false,
        tasks: action.payload.tasks,
        successGetDashboardFinishTasks: action.payload.message,
      };
      break;
    case GET_DASHBOARD_FINISH_TASKS_ERROR:
      state = { ...state, errorGetDashboardFinishTasks: action.payload, loadingGetDashboardFinishTasks: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getDashboardFinishTasks;
